/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiCaseAssignedStatus
 */
export interface InternalApiCaseAssignedStatus {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCaseAssignedStatus
     */
    code: string;
}

/**
 * Check if a given object implements the InternalApiCaseAssignedStatus interface.
 */
export function instanceOfInternalApiCaseAssignedStatus(value: object): value is InternalApiCaseAssignedStatus {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function InternalApiCaseAssignedStatusFromJSON(json: any): InternalApiCaseAssignedStatus {
    return InternalApiCaseAssignedStatusFromJSONTyped(json, false);
}

export function InternalApiCaseAssignedStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseAssignedStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

export function InternalApiCaseAssignedStatusToJSON(json: any): InternalApiCaseAssignedStatus {
    return InternalApiCaseAssignedStatusToJSONTyped(json, false);
}

export function InternalApiCaseAssignedStatusToJSONTyped(value?: InternalApiCaseAssignedStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

